import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import './App.css';
import { HalfwayProvider } from "./context/HalfwayProvider";
import { Menu } from "./containers/Menu";
import { NoCourseProvided } from "./containers/errors/NoCourseProvided";
import { Success } from "./containers/Success/success";
import { ViewOrder } from "./containers/viewOrder/ViewOrder";
import { ViewOrderProvider } from "./context/viewOrderContext/ViewOrderProvider";
import { PrivacyPolicy } from "./containers/PrivacyPolicy";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<NoCourseProvided />} />
                <Route path='success' element={
                    <HalfwayProvider>
                        <Success />
                    </HalfwayProvider>
                } />
                <Route path='privacy-policy' element={<PrivacyPolicy />} />
                <Route path='/:courseId' element={
                    <HalfwayProvider>
                        <Menu />
                    </HalfwayProvider>
                } />
                <Route path='/orders/:courseId/:orderId' element={
                    <ViewOrderProvider>
                        <ViewOrder />
                    </ViewOrderProvider>
                }
                />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
